// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"788":"0ad1f95a","797":"d9d86ec9"}[chunkId] + ".chunk.js";
};